import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import { useAuth } from '../contexts/AuthContext';
import CustomStatisticsModal from '../components/CustomStatisticsModal';

const Dashboard: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [isStatsModalOpen, setIsStatsModalOpen] = useState(false);

  // Only show dashboard for admin users
  if (user?.role !== 'administrator') {
    return (
      <div className="dashboard-page">
        <Header />
        <div className="dashboard-content">
          <div className="container">
            <h1>Ingen tilgang</h1>
            <p>Du har ikke tilgang til dashboardet. Kun administratorer kan se denne siden.</p>
          </div>
        </div>
      </div>
    );
  }

  const handleGenerateStats = (filters: any) => {
    setIsStatsModalOpen(false);
    navigate('/statistics/custom', { state: { filters } });
  };

  return (
    <div className="dashboard-page">
      <Header />
      <div className="dashboard-content">
        <div className="container">
          <h1>Administrator Dashboard</h1>
          <p>Velkommen til administrator-dashboardet, {user.firstName}!</p>

          <div className="dashboard-grid">
            <div className="dashboard-card">
              <h3>Brukerstyring</h3>
              <p>Administrer brukere og tilganger</p>
              <button
                className="btn btn-primary"
                onClick={() => navigate('/dashboard/users')}
              >
                Åpne brukerstyring
              </button>
            </div>

            <div className="dashboard-card">
              <h3>Statistikk</h3>
              <p>Se rapporter og statistikk</p>
              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                <button
                  className="btn btn-primary"
                  onClick={() => navigate('/dashboard/statistics')}
                >
                  Se statistikk
                </button>
                <button
                  className="btn btn-secondary"
                  onClick={() => setIsStatsModalOpen(true)}
                >
                  Lag statistikk
                </button>
              </div>
            </div>

            <div className="dashboard-card">
              <h3>Skjemainnsendinger</h3>
              <p>Se alle innsendte salgsskjemaer</p>
              <button
                className="btn btn-primary"
                onClick={() => navigate('/dashboard/submissions')}
              >
                Se innsendinger
              </button>
            </div>
          </div>
        </div>
      </div>

      <CustomStatisticsModal
        isOpen={isStatsModalOpen}
        onClose={() => setIsStatsModalOpen(false)}
        onGenerate={handleGenerateStats}
      />
    </div>
  );
};

export default Dashboard;